import {
  Alert,
  Box,
  Button,
  ButtonProps,
  Dialog,
  MenuItem,
  MenuItemProps,
  Stack,
  styled,
} from '@mui/material';
import TicDialog from 'components/forms/TicDialog';
import { useMuiDialog } from 'components/utils/useDialog';
import React from 'react';

export const TeachingStaffFlexbox = styled(Box)(({ theme }) => ({
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  columnGap: theme.spacing(4),
  rowGap: theme.spacing(2),
  flexWrap: 'wrap',
}));

export const TeachingStaffInteractiveArea = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[100]}`,
  borderRadius: '8px',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[50],
}));

export const TeachingStaffClickableArea = styled(TeachingStaffInteractiveArea)(
  ({ theme }) => ({
    ':hover': {
      backgroundColor: theme.palette.grey[200],
      cursor: 'pointer',
    },
  })
);

export const ErrorAlert: React.FC<{ error: any }> = ({ error }) => {
  let message = 'Unknown Error';
  if ('message' in error) {
    // eslint-disable-next-line prefer-destructuring
    message = error.message;
  }
  return <Alert severity="error">{message}</Alert>;
};

type ConfirmDangerousButtonProps = Omit<ButtonProps, 'onClick'> & {
  onConfirm(): void;
  title?: string;
};
export const ConfirmDangerousButton = ({
  onConfirm,
  title = 'Are you sure?',
  ...rest
}: ConfirmDangerousButtonProps) => {
  const confirmDialog = useMuiDialog();
  return (
    <>
      <Button {...rest} onClick={confirmDialog.setOpen} />
      <Dialog {...confirmDialog.props}>
        <TicDialog title={title} onComplete={confirmDialog.setClosed}>
          <Stack spacing={2}>
            <Button
              onClick={() => {
                confirmDialog.setClosed();
                onConfirm();
              }}
              variant="outlined"
              fullWidth
            >
              Yes, I'm sure
            </Button>
            <Button onClick={confirmDialog.setClosed} fullWidth>
              Cancel
            </Button>
          </Stack>
        </TicDialog>
      </Dialog>
    </>
  );
};

type ConfirmDangerousMenuItemProps = Omit<MenuItemProps, 'onClick'> & {
  onConfirm(): void;
  title?: string;
};
export const ConfirmDangerousMenuItem = ({
  onConfirm,
  title = 'Are you sure?',
  ...rest
}: ConfirmDangerousMenuItemProps) => {
  const confirmDialog = useMuiDialog();
  return (
    <div>
      <MenuItem {...rest} onClick={confirmDialog.setOpen} />
      <Dialog {...confirmDialog.props}>
        <TicDialog title={title} onComplete={confirmDialog.setClosed}>
          <Stack spacing={2}>
            <Button
              onClick={() => {
                confirmDialog.setClosed();
                onConfirm();
              }}
              variant="outlined"
              fullWidth
            >
              Yes, I'm sure
            </Button>
            <Button onClick={confirmDialog.setClosed} fullWidth>
              Cancel
            </Button>
          </Stack>
        </TicDialog>
      </Dialog>
    </div>
  );
};
